export const namespaced = true;

export const state = {
  sl_a: 0,
  sl_b: 0,
  sl_c: 0,
  question_a: "",
  question_b: "",
  question_c: "",
  question_d: "",
  question_e: "",
  question_f: "",
  question_g: "",
  question_h: "",
  question_i: "",
  question_j: "",
  question_k: "",
  question_l: "",
  question_m: "",
  question_n: "",
  question_o: "",
  question_p: "",
  question_q: "",
  question_r: "",
  question_s: "",
  question_t: "",
  question_u: "",
  question_v: "",
  question_w: "",
  text_a: null,
  text_b: null,
  text_c: null,
  text_d: null,
  text_e: null,
  text_f: null,
  text_g: null,
  text_h: null,
  text_i: null,
  text_j: null,
  text_k: null,
  text_l: null,
};
export const mutations = {
  update_sl_a(state, sl_a) {
    state.sl_a = sl_a;
  },
  update_sl_b(state, sl_b) {
    state.sl_b = sl_b;
  },
  update_sl_c(state, sl_c) {
    state.sl_c = sl_c;
  },
  update_question_a(state, question_a) {
    state.question_a = question_a;
  },
  update_question_b(state, question_b) {
    state.question_b = question_b;
  },
  update_question_c(state, question_c) {
    state.question_c = question_c;
  },
  update_question_d(state, question_d) {
    state.question_d = question_d;
  },
  update_question_e(state, question_e) {
    state.question_e = question_e;
  },
  update_question_f(state, question_f) {
    state.question_f = question_f;
  },
  update_question_g(state, question_g) {
    state.question_g = question_g;
  },
  update_question_h(state, question_h) {
    state.question_h = question_h;
  },
  update_question_i(state, question_i) {
    state.question_i = question_i;
  },
  update_question_j(state, question_j) {
    state.question_j = question_j;
  },
  update_question_k(state, question_k) {
    state.question_k = question_k;
  },
  update_question_l(state, question_l) {
    state.question_l = question_l;
  },
  update_question_m(state, question_m) {
    state.question_m = question_m;
  },
  update_question_n(state, question_n) {
    state.question_n = question_n;
  },
  update_question_o(state, question_o) {
    state.question_o = question_o;
  },
  update_question_p(state, question_p) {
    state.question_p = question_p;
  },
  update_question_q(state, question_q) {
    state.question_q = question_q;
  },
  update_question_r(state, question_r) {
    state.question_r = question_r;
  },
  update_question_s(state, question_s) {
    state.question_s = question_s;
  },
  update_question_t(state, question_t) {
    state.question_t = question_t;
  },
  update_question_u(state, question_u) {
    state.question_u = question_u;
  },
  update_question_v(state, question_v) {
    state.question_v = question_v;
  },
  update_question_w(state, question_w) {
    state.question_w = question_w;
  },
  update_text_a(state, text_a) {
    state.text_a = text_a;
  },
  update_text_b(state, text_b) {
    state.text_b = text_b;
  },
  update_text_c(state, text_c) {
    state.text_c = text_c;
  },
  update_text_d(state, text_d) {
    state.text_d = text_d;
  },
  update_text_e(state, text_e) {
    state.text_e = text_e;
  },
  update_text_f(state, text_f) {
    state.text_f = text_f;
  },
  update_text_g(state, text_g) {
    state.text_g = text_g;
  },
  update_text_h(state, text_h) {
    state.text_h = text_h;
  },
  update_text_i(state, text_i) {
    state.text_i = text_i;
  },
  update_text_j(state, text_j) {
    state.text_j = text_j;
  },
  update_text_k(state, text_k) {
    state.text_k = text_k;
  },
  update_text_l(state, text_l) {
    state.text_l = text_l;
  },
};
export const getters = {
  sl_a: (state) => {
    return state.sl_a;
  },
  sl_b: (state) => {
    return state.sl_b;
  },
  sl_c: (state) => {
    return state.sl_c;
  },
  question_a: (state) => {
    return state.question_a;
  },
  question_b: (state) => {
    return state.question_b;
  },
  question_c: (state) => {
    return state.question_c;
  },
  question_d: (state) => {
    return state.question_d;
  },
  question_e: (state) => {
    return state.question_e;
  },
  question_f: (state) => {
    return state.question_f;
  },
  question_g: (state) => {
    return state.question_g;
  },
  question_h: (state) => {
    return state.question_h;
  },
  question_i: (state) => {
    return state.question_i;
  },
  question_j: (state) => {
    return state.question_j;
  },
  question_k: (state) => {
    return state.question_k;
  },
  question_l: (state) => {
    return state.question_l;
  },
  question_m: (state) => {
    return state.question_m;
  },
  question_n: (state) => {
    return state.question_n;
  },
  question_o: (state) => {
    return state.question_o;
  },
  question_p: (state) => {
    return state.question_p;
  },
  question_q: (state) => {
    return state.question_q;
  },
  question_r: (state) => {
    return state.question_r;
  },
  question_s: (state) => {
    return state.question_s;
  },
  question_t: (state) => {
    return state.question_t;
  },
  question_u: (state) => {
    return state.question_u;
  },
  question_v: (state) => {
    return state.question_v;
  },
  question_w: (state) => {
    return state.question_w;
  },
  text_a: (state) => {
    return state.text_a;
  },
  text_b: (state) => {
    return state.text_b;
  },
  text_c: (state) => {
    return state.text_c;
  },
  text_d: (state) => {
    return state.text_d;
  },
  text_e: (state) => {
    return state.text_e;
  },
  text_f: (state) => {
    return state.text_f;
  },
  text_g: (state) => {
    return state.text_g;
  },
  text_h: (state) => {
    return state.text_h;
  },
  text_i: (state) => {
    return state.text_i;
  },
  text_j: (state) => {
    return state.text_j;
  },
  text_k: (state) => {
    return state.text_k;
  },
  text_l: (state) => {
    return state.text_l;
  },
};
